import React from "react";
import PropTypes from "prop-types";
import { VIEW_COLUMNS } from "../../../../config/deviceColumnsConfig";

const ViewDeviceRow = ({ device, selectedDevice, onRowClick }) => {
  const isSelected =
    selectedDevice && selectedDevice.deviceId === device.deviceId;
  return (
    <tr
      onClick={() => onRowClick(device)}
      className={`border-t cursor-pointer ${
        isSelected ? "bg-cyan-100" : "bg-transparent"
      } ${!isSelected ? "hover:bg-cyan-50 hover:shadow-lg" : ""}`}
    >
      {VIEW_COLUMNS.map((col) => (
        <td key={col.key} className="px-1 py-1 border">
          {col.render ? col.render(device) : device[col.key]}
        </td>
      ))}
    </tr>
  );
};

ViewDeviceRow.propTypes = {
  device: PropTypes.object.isRequired,
  selectedDevice: PropTypes.object,
  onRowClick: PropTypes.func.isRequired,
};

export default ViewDeviceRow;
